var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhonePe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_524_2599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.4833 51.5431C87.7628 29.2226 73.9177 6.85573 51.5594 1.58516C29.2012 -3.6854 6.79639 10.1362 1.51689 32.4566C-3.7626 54.7771 10.0825 77.144 32.4407 82.4145C54.7989 87.6851 77.2038 73.8635 82.4833 51.5431Z",
    fill: "#5F259F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8791 31.1625C60.8791 29.5385 59.4848 28.1466 57.8581 28.1466H52.2809L39.4999 13.5313C38.338 12.1393 36.4789 11.6753 34.6198 12.1393L30.2046 13.5313C29.5074 13.7633 29.275 14.6912 29.7398 15.1552L43.6828 28.3786H22.5359C21.8388 28.3786 21.374 28.8426 21.374 29.5385V31.8584C21.374 33.4824 22.7683 34.8743 24.395 34.8743H27.6484V46.0098C27.6484 54.3614 32.0636 59.2332 39.4999 59.2332C41.8237 59.2332 43.6828 59.0012 46.0066 58.0733V65.4969C46.0066 67.5848 47.6333 69.2088 49.7247 69.2088H52.9781C53.6752 69.2088 54.3724 68.5128 54.3724 67.8168V34.6423H59.7172C60.4143 34.6423 60.8791 34.1783 60.8791 33.4824V31.1625ZM46.0066 51.1136C44.6123 51.8095 42.7532 52.0415 41.3589 52.0415C37.6408 52.0415 35.7818 50.1856 35.7818 46.0098V34.8743H46.0066V51.1136Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_524_2599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonePe);
export default __webpack_public_path__ + "static/media/PhonePe.8e914e2482e2ceae44a8f4ba451da5ab.svg";
export { ForwardRef as ReactComponent };